import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { NgxsModule } from "@ngxs/store";

import { NgbdSortableHeaderDirective } from "./directives";
import {
    ClaseEnvioCssPipe,
    EstadoEncuestaPipe,
    EstadoEnvioTextoPipe,
    FechaAmigableEnvioPipe,
    FiltrarTablaPipe,
    NombreAmigableRutaPipe,
    NombreTipoAccionPipe,
    NombreTipoPreguntaPipe,
    ObjetivoAccionPipe,
    PaginatePipe,
    SacarNullPipe,
    ToStrEventPipe,
    ToStrStatePipe,
    TraducirPipe,
    NombreLargoTipoEnvioPipe,
    NombreTipoEstudioPipe,
    NombreEstadoEstudioPipe,
    CondicionTextoPipe,
    NombreBitacoraTipoPipe,
    NombreGeneroPipe,
    IncludesPipe
} from "./pipes";
import { ClientesState } from "./states";

const pipes = [
    ToStrEventPipe,
    ToStrStatePipe,
    SacarNullPipe,
    TraducirPipe,
    PaginatePipe,
    EstadoEnvioTextoPipe,
    ClaseEnvioCssPipe,
    FechaAmigableEnvioPipe,
    EstadoEncuestaPipe,
    NombreAmigableRutaPipe,
    NombreTipoPreguntaPipe,
    NombreLargoTipoEnvioPipe,
    NombreTipoEstudioPipe,
    NombreEstadoEstudioPipe,
    FiltrarTablaPipe,
    CondicionTextoPipe,
    NombreTipoAccionPipe,
    ObjetivoAccionPipe,
    NombreBitacoraTipoPipe,
    NombreGeneroPipe,
    IncludesPipe
];

const directives = [
    NgbdSortableHeaderDirective
];

@NgModule({
    declarations: [
        ...pipes,
        ...directives
    ],
    imports: [
        CommonModule,
        NgxsModule.forFeature([ClientesState])
    ],
    exports: [
        ...pipes,
        ...directives
    ]
})
export class SharedModule {}
